<template>
  <div>
    <div class="display_between marginTop20"
         v-for="(item,index) in datapageList"
         :key="index">
      <div class="pub_square"
           @click="courseclick(itemn)"
           v-for="(itemn,indexn) in item"
           :key="indexn">
        <div class="pubs_img">
          <img class="pubs_img img"
               :src="itemn.img">
        </div>
        <div class="pubs_body">
          <div class="pubs_title">
            {{ellipsis(itemn.title,18)}}
          </div>
          <div class="pubs_label display_between">
            <div>
              <!-- <span class="gree_block" v-for="(itemX,indexX) in item.labelname.split(',')" :key="'0'+indexX">{{itemX}}</span> -->

              <span v-bind:class="calculate(index)"
                    class="gl_gree_block"
                    v-for="(t,index) in (itemn.labelname || '').split(',')"
                    :key="index"
                    @click="labelclick(t)">
                {{t}}
              </span>
            </div>
            <!-- <div class="pubs_cancel">
                        取消收藏
                    </div> -->
          </div>
          <div class="display_between">
            <div class="pubs_tip">
              <span>{{formatTime(itemn.ptime,'YYYY/MM/DD')}}</span>
            </div>
            <!-- <div class="pubs_rentou">
                        <img src="/image/geren/ren.png">{{itemn.num}}人
                    </div> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import format from '@/assets/unit/unit.js'
// import lodash from "lodash"
export default {
  name: "inTagCourse",
  props: ['datapageList'],
  data () {
    return {
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
    }
  },
  methods: {
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat)
    },
    calculate (index) {
      var nm = this.colorList[Math.floor(index % 3)]
      return nm
    },
    //课程跳转
    courseclick (item) {
      let id = item.id == 0 ? item.id : item.id
      let url = this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id
      window.open(url)
    },
    /**tianlianpei */
    biaoqianFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '')
        .replace(/\|/g, '；')
    },
    textFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '')
    },
    delHtmlTag (str) {
      return str.replace(/<[^>]+>/g, '') //去掉所有的html标记
    },
  },
  created () {
  },
}
</script>

<style scoped>
.pubs_img img {
    width: 300px;
    height: 158px;
}
.gl_gree_block {
    height: 19px;
    line-height: 19px;
}
</style>
